

































import Vue from "vue";
import moment from "moment";

// Vuex
import { mapState } from "vuex";
import { RootState } from "@/store";

// Vue components
import OldDataAlertIcon from "@/components/OldDataAlertIcon.vue";

// Model
import { AgentInfo } from "@/model/data/agent/AgentInfo";
import { LocalStorageManager, LocalStorageRequests } from "@/plugins/LocalStorageManager";

export default Vue.extend({
    components: { OldDataAlertIcon },
    data() {
        let displaySectionsList = [true, true, true, true, true];
        let value = LocalStorageManager.Read(LocalStorageRequests.DisplaySectionList);
        if (value) displaySectionsList = JSON.parse(LocalStorageManager.Read(LocalStorageRequests.DisplaySectionList));
        return {
            moment,
            displaySectionsList: displaySectionsList,
        };
    },
    props: {
        agentInfo: { type: Object as () => AgentInfo, required: true },
    },
    computed: {
        ...mapState({
            configuration: (state: any) => state.configuration,
            userTheme: (state: RootState) => state.authMod.currentUser.userConfig.theme,
        }),
        borderLeftStyle() {
            if (this.userTheme == "dark") return "border-left: thin solid rgba(255, 255, 255, 0.3)";
            return "border-left: thin solid rgba(0, 0, 0, 0.12)";
        },
    },
    methods: {
        changeDisplaySectionValue(value: boolean) {
            this.displaySectionsList.splice(4, 1, value);
            LocalStorageManager.Write(LocalStorageRequests.DisplaySectionList, JSON.stringify(this.displaySectionsList));
            window.dispatchEvent(
                new CustomEvent("display-section-key-localstorage-changed", {
                    detail: {
                        index: 4,
                        value: value,
                    },
                })
            );
        },
    },
    mounted() {
        window.addEventListener("display-section-key-localstorage-changed", (event: any) => {
            if (this.displaySectionsList[event.detail.index] != event.detail.value) {
                this.displaySectionsList.splice(event.detail.index, 1, event.detail.value);
            }
        });
    },
});
